/* Fiche produit : un état de variante, partagé par la galerie et les deux boutons d'achat. */
(function () {
  function init(fiche) {
    if (fiche.dataset.pdpPret) return;
    fiche.dataset.pdpPret = 'true';
    var form = fiche.querySelector('.section-fiche__form');
    if (!form) return;
    var bouton = form.querySelector('.section-fiche__ajouter');
    var quantite = form.querySelector('[name="quantity"]');
    var erreurQuantite = form.querySelector('[data-pdp-erreur-quantite]');
    var barre = document.querySelector('[data-barre]');
    var boutonBarre = barre && barre.querySelector('[data-pdp-ajout-collant]');
    var image = fiche.querySelector('.section-fiche__img');
    var vignettes = Array.from(fiche.querySelectorAll('.section-fiche__vignette'));
    var position = fiche.querySelector('[data-pdp-position]');
    var zoom = fiche.querySelector('[data-pdp-zoom]');
    var dialogue = fiche.querySelector('dialog');
    // -1 quand la grande image n'est dans aucune vignette : un contenant
    // (boite) rendu par l'adresse ou choisi dans le selecteur de format.
    var index = vignettes.findIndex(function (v) { return v.classList.contains('est-actif'); });
    function selection() { return form.querySelector('[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]'); }
    function nombre() { return Number(quantite.value); }
    function valide() {
      var ok = quantite.value.trim() !== '' && Number.isSafeInteger(nombre()) && nombre() >= 1;
      quantite.setAttribute('aria-invalid', String(!ok));
      if (erreurQuantite) erreurQuantite.hidden = ok;
      return ok;
    }
    function montant(choix) {
      if (!Number.isSafeInteger(nombre()) || nombre() < 1 || nombre() === 1) return choix.dataset.prix;
      return new Intl.NumberFormat('en-CH', { style: 'currency', currency: fiche.dataset.currency || 'CHF', currencyDisplay: 'code' }).format(Number(choix.dataset.prixCentimes) * nombre() / 100);
    }
    function sync() {
      var choix = selection();
      if (!choix) return;
      var resumeFormat = fiche.querySelector('[data-format-resume]');
      var premierFormat = form.querySelector('[name="id"]');
      if (resumeFormat) resumeFormat.textContent = choix === premierFormat ? '' : choix.dataset.format + ' · ' + choix.dataset.prix;
      var disponible = choix.dataset.disponible === 'true';
      var libelle = disponible ? 'Ajouter au panier · ' + montant(choix) : 'Épuisé';
      var occupe = form.getAttribute('aria-busy') === 'true';
      bouton.dataset.available = String(disponible);
      bouton.dataset.addLabel = libelle;
      if (!occupe) { bouton.disabled = !disponible; bouton.textContent = libelle; }
      var moins = fiche.querySelector('[data-pdp-moins]');
      if (moins) moins.disabled = nombre() <= 1;
      if (barre) {
        barre.querySelector('[data-barre-prix]').textContent = montant(choix);
        barre.querySelector('.section-barre__format').textContent = choix.dataset.format || '';
        if (boutonBarre) { boutonBarre.disabled = !disponible || occupe; boutonBarre.textContent = occupe ? 'Ajout…' : disponible ? 'Ajouter au panier' : 'Épuisé'; }
      }
    }
    function montrerImage(vignette) {
      if (!image || !vignette) return;
      index = vignettes.indexOf(vignette);
      image.src = vignette.dataset.image;
      image.alt = vignette.dataset.alt || '';
      if (vignette.dataset.srcset) image.srcset = vignette.dataset.srcset;
      else image.removeAttribute('srcset');
      vignettes.forEach(function (v) {
        var actif = v === vignette;
        v.classList.toggle('est-actif', actif);
        if (actif) v.setAttribute('aria-current', 'true'); else v.removeAttribute('aria-current');
      });
      if (position) position.textContent = (index + 1) + ' / ' + vignettes.length;
      if (zoom) zoom.href = vignette.href;
    }
    function montrerContenant(choix) {
      // Le contenant choisi n'est pas dans la galerie : on le montre en grand,
      // aucune vignette n'est active, et le compteur dit ce qui est affiche.
      index = -1;
      image.src = choix.dataset.image; image.alt = choix.dataset.alt || ''; image.removeAttribute('srcset');
      vignettes.forEach(function (v) { v.classList.remove('est-actif'); v.removeAttribute('aria-current'); });
      if (position) position.textContent = choix.dataset.format || '';
      if (zoom) zoom.href = choix.dataset.zoom || choix.dataset.image;
    }
    function deplacer(delta) {
      // Depuis un contenant hors galerie, « suivant » ouvre la premiere vignette et « precedent » la derniere.
      var cible = index < 0 ? (delta > 0 ? 0 : vignettes.length - 1) : (index + delta + vignettes.length) % vignettes.length;
      montrerImage(vignettes[cible]);
    }
    fiche.addEventListener('click', function (e) {
      var vignette = e.target.closest('.section-fiche__vignette');
      if (vignette && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) { e.preventDefault(); montrerImage(vignette); }
      if (e.target.closest('[data-pdp-precedent]')) deplacer(-1);
      if (e.target.closest('[data-pdp-suivant]')) deplacer(1);
      if (e.target.closest('[data-pdp-moins], [data-pdp-plus]')) {
        var actuel = Number.isSafeInteger(nombre()) && nombre() > 0 ? nombre() : 1;
        quantite.value = Math.max(1, actuel + (e.target.closest('[data-pdp-plus]') ? 1 : -1));
        valide(); sync();
      }
    });
    quantite.addEventListener('blur', function () { valide(); sync(); });
    quantite.addEventListener('input', function () { if (quantite.getAttribute('aria-invalid') === 'true') valide(); sync(); });
    form.addEventListener('submit', function (e) {
      if (!valide()) { e.preventDefault(); e.stopPropagation(); quantite.focus(); }
    }, true);
    form.noValidate = true;
    form.addEventListener('chanoyu:pdp-sync', sync);
    form.addEventListener('change', function (e) {
      var choix = e.target;
      if (choix.name !== 'id') return;
      fiche.querySelectorAll('.section-fiche__format').forEach(function (v) { v.classList.toggle('est-actif', v.contains(choix)); });
      fiche.querySelector('.section-fiche__prix').textContent = choix.dataset.prix;
      var stock = fiche.querySelector('.section-fiche__stock');
      stock.textContent = choix.dataset.disponible === 'true' ? stock.dataset.stockDisponible : 'Ce format est épuisé.';
      var infos = fiche.querySelector('[data-infos-format]');
      var modele = fiche.querySelector('[data-infos-variante="' + choix.value + '"]');
      if (infos && modele) infos.replaceChildren(modele.content.cloneNode(true));
      var photo = vignettes.find(function (v) { return v.dataset.image === choix.dataset.image; });
      if (photo) montrerImage(photo);
      else if (image && choix.dataset.image) montrerContenant(choix);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', choix.value);
      window.history.replaceState(window.history.state, '', url);
      sync();
    });
    if (vignettes.length > 1) {
      fiche.querySelector('[data-pdp-galerie-navigation]').hidden = false;
      // Arrivee sur un contenant (?variant= une boite) : la grande image rendue
      // par le serveur reste, le compteur nomme le format coche.
      if (index >= 0) montrerImage(vignettes[index]);
      else if (position) position.textContent = (selection() || {dataset: {}}).dataset.format || '';
      var depart;
      var principal = fiche.querySelector('.section-fiche__principal');
      principal.style.touchAction = 'pan-y pinch-zoom';
      principal.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') depart = { x: e.clientX, y: e.clientY }; });
      principal.addEventListener('pointerup', function (e) {
        if (!depart) return;
        var dx = e.clientX - depart.x, dy = e.clientY - depart.y; depart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) deplacer(dx > 0 ? -1 : 1);
      });
      principal.addEventListener('pointercancel', function () { depart = null; });
    }
    if (zoom && dialogue && typeof dialogue.showModal === 'function') {
      zoom.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        var agrandie = dialogue.querySelector('[data-pdp-zoom-image]');
        agrandie.src = zoom.href; agrandie.alt = image.alt;
        dialogue.showModal(); dialogue.querySelector('h2').focus();
      });
      dialogue.querySelector('[data-pdp-fermer]').addEventListener('click', function () { dialogue.close(); });
      dialogue.addEventListener('close', function () { zoom.focus(); });
      dialogue.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') { e.preventDefault(); dialogue.querySelector('[data-pdp-fermer]').focus(); }
      });
    }
    if (boutonBarre) boutonBarre.setAttribute('form', form.getAttribute('id'));
    if (barre && 'ResizeObserver' in window) {
      var tailleBarre = new ResizeObserver(function () { document.documentElement.style.setProperty('--pdp-barre-hauteur', barre.getBoundingClientRect().height + 'px'); });
      tailleBarre.observe(barre);
      document.addEventListener('shopify:section:unload', function (e) { if (e.target.contains(fiche)) tailleBarre.disconnect(); });
    }
    if (barre && 'IntersectionObserver' in window) {
      function afficherBarre(rect) { barre.hidden = rect.bottom > 120; }
      var observer = new IntersectionObserver(function (entries) {
        afficherBarre(entries[0].boundingClientRect);
      }, { rootMargin: '-120px 0px 0px 0px' });
      observer.observe(bouton);
      // Un saut d'ancre peut passer de sous à au-dessus du viewport sans intersection.
      var frame;
      function auDefilement() {
        if (frame) return;
        frame = window.requestAnimationFrame(function () { frame = null; afficherBarre(bouton.getBoundingClientRect()); });
      }
      window.addEventListener('scroll', auDefilement, { passive: true });
      window.addEventListener('resize', auDefilement);
      document.addEventListener('shopify:section:unload', function (e) {
        if (!e.target.contains(fiche)) return;
        observer.disconnect(); window.removeEventListener('scroll', auDefilement); window.removeEventListener('resize', auDefilement);
        if (frame) window.cancelAnimationFrame(frame);
      });
      var statut = form.querySelector('[data-ajout-statut]');
      var statutBarre = barre.querySelector('[data-barre-statut]');
      if (statut && statutBarre && 'MutationObserver' in window) new MutationObserver(function () {
        statutBarre.replaceChildren.apply(statutBarre, Array.from(statut.childNodes).map(function (noeud) { return noeud.cloneNode(true); }));
      }).observe(statut, { childList: true, subtree: true, characterData: true });
    }
    sync();
  }
  function demarrer(root) { root.querySelectorAll('[data-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { demarrer(document); });
  else demarrer(document);
  document.addEventListener('shopify:section:load', function (e) { demarrer(e.target); });
})();
